import { FileModelHelper } from "./file-parser";
import { Event, getItemTopicFromEvent, EventTypeMap } from "./types";
import { as_displayed_actor } from "@/common/ai-agent";

const PII_LABELS_CATEGORY_TO_HIDE = [
  "MIP Labels",
  "Virtual",
  "Has MIP Label",
  "External Information",
  "Internal Information",
];

export const eventParser = (event: Event) => {
  // const label = { ...default_label, concreteScore: 0.1, type: "Content" };
  let all_labels = { labels: new Set(), piis: new Set() };
  event.items = event.items?.filter((item) => item?.labels);
  if (event.items && event.items.length > 0) {
    all_labels = event.items.reduce(
      (acc, item) => {
        // @ts-ignore
        const { infoLabel, piis = [] } = item!.labels;
        if (infoLabel) {
          // @ts-ignore
          acc.labels.add(infoLabel.name);
        }
        // filtering out piis with non relevant for display label categories
        piis
          .filter((p: any) => {
            return !PII_LABELS_CATEGORY_TO_HIDE.includes(p.labelCategory);
          })
          .forEach((p: any) => acc.piis.add(p.name));
        return acc;
      },
      { labels: new Set(), piis: new Set() },
    );
  }
  if (all_labels.labels.size > 0) {
    all_labels.labels.delete("Other");
  }
  if (all_labels.labels.size == 0) {
    if (all_labels.piis.size > 0) {
      all_labels.labels = all_labels.piis;
    } else {
      // @ts-ignore
      all_labels.labels.add("Other");
    }
  }

  if (all_labels.piis.size > 0) {
    // @ts-ignore
    all_labels.piis = Array.from(all_labels.piis.values());
  }
  // @ts-ignore
  all_labels.labels = Array.from(all_labels.labels.values()).join(", ");
  // @ts-ignore
  const selected_item = event.items?.length > 0 ? event.items[0] : null;
  let display_item = null;

  const has_item_with_email_body = event.items?.some(
    (d) => d?.subType == "Email" && d?.category == "Content",
  );
  if (selected_item) {
    const archive_items_tooltip_raw = (selected_item.internalItems || [])
      .filter((d: any) => d && d.name)
      .map((d: any) => d.name);
    const archive_items_tooltip =
      archive_items_tooltip_raw.length > 5
        ? [...archive_items_tooltip_raw.slice(0, 5), "and other files"]
        : archive_items_tooltip_raw;
    const archive_name =
      (selected_item.archive && selected_item.archive.archiveName) ||
      selected_item.name;
    // @ts-ignore
    const { infoLabel, adhocLabels } = selected_item.labels;
    const contains_adhoc = adhocLabels.length > 0;
    display_item = {
      id: selected_item.id,
      name: selected_item.name,
      main_label: {
        ...infoLabel,
      },
      is_email_body: FileModelHelper.is_email_body(selected_item),
      archive: selected_item.archive,
      archive_name,
      archive_items_tooltip,
      adhoc: {
        has: contains_adhoc,
        name: contains_adhoc
          ? adhocLabels.map((d: any) => d.name).join(",")
          : "",
      },
    };
  }
  const triageSource = (event as any).triage;
  const triage = triageSource
    ? {
        decision: triageSource.decision,
      }
    : null;

  const res = {
    id: event.id,
    date: event.date,
    justification: event.justification,
    mark: event.mark ?? null,
    items: event.items,
    has_item_with_email_body,
    // @ts-ignore
    all_labels,
    // AI agents read by their display name and never by address (task 25233)
    exposedBy: (event as any).relatedEntities?.exposedBy?.entity
      ? as_displayed_actor((event as any).relatedEntities.exposedBy.entity)
      : null,
    exposedTo: ((event as any).relatedEntities?.exposedTo || [])
      .map((d: any) => d?.entity)
      .filter(Boolean)
      .map(as_displayed_actor),
    insights: event.insights,
    severity: event.severity ?? 0,
    source: event.sourceApplication,
    // @ts-ignore
    event_type: event.subType ? EventTypeMap[event.subType] : "",
    topic: getItemTopicFromEvent(event),
    // @ts-ignore
    file_upload_path: event.relatedEntities?.fileUploadPath,
    display_item,
    // @ts-ignore
    story: triageSource?.desc || "",
    // @ts-ignore
    triage,
  } as any;
  return res;
};
